<template>
  <div class="container">
    <div class="live-box" v-if="lists.length > 0">
      <div
        class="item"
        v-for="(item, index) in lists"
        :key="index"
        :style="{ marginRight: screenWidth <= 1280 ? '0px' : '24px' }"
        @click="goDetail(item.obj.id)"
      >
        <div class="vedio">
          <img
            src="../../../static/icon_del.png"
            @click.stop="delItem(item.id)"
            class="shoucang"
          />

          <img
            class="vedio_picture"
            :src="baseUrl + item.obj.column15"
            v-if="item.obj.column15.includes('/hz/hzupload')"
          />

          <img src="../../../static/占位-活动-列表.png" alt="" v-else />
        </div>

        <div class="title">
          <div class="titleTxt">{{ item.obj.actTitle }}</div>

          <!------------------------------------------------------------->
          <div class="startTime">
            <img src="../../../static/ico_time.png" alt="" />
            <div class="txt">{{ item.obj.startTime }}</div>
          </div>
          <!------------------------------------------------------------->

          <div class="startTime">
            <img src="../../../static/ico_address.png" />

            <div class="txt">
              <div class="sity">{{ item.obj.address }}</div>
            </div>
          </div>
          <!------------------------------------------------------------->
        </div>

        <!---------公司名称------------>
        <div class="down">
          {{ item.obj.hzExhibitor.companyNameC }}
        </div>
      </div>
    </div>
    <div class="boxImg" v-else>
      <img src="../../../static/empty.png" alt="" />
      <div>{{ $t("search.nocCollect") }}</div>
    </div>
  </div>
</template>
<script>
import { forMat, backActivityDetail } from "../../../../utils/common.js";
import { getColActivityLists, delCollect } from "../../../../api/collection.js";

export default {
  data() {
    return {
      baseUrl: forMat(),
      lists: [],
      screenWidth: "",
      activityDetailUrl: backActivityDetail(),
    };
  },
  created() {
    this.getLists();
    this.init();
  },
  methods: {
    goDetail(id) {
      window.location.href = this.activityDetailUrl + "?id=" + id;
    },
    init() {
      this.screenWidth = window.screen.width;
    },
    async getLists() {
      try {
        const { data } = await getColActivityLists();
        if (data.code === 200) {
          this.lists = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async delItem(id) {
      const params1 = {
        id: id,
      };
      try {
        const { data } = await delCollect(params1);
        if (data.code === 200) {
          this.getLists();
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 161px);
  background-color: white;
  padding: 15px 15px 0px 15px;
  box-sizing: border-box;
  .live-box {
    display: grid;
    grid-template-columns: repeat(2, 48%);
    justify-content: space-between;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    .item {
      border: 1px solid #e0e0e0;
      cursor: pointer;

      .vedio {
        width: 100%;
        height: 104px;

        position: relative;
        .shoucang {
          position: absolute;
          z-index: 9;
          right: 0px;
          top: 0px;
          width: 14px;
          height: 14px;
        }
        .vedio_picture {
          max-width: 100%;
          max-height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      .title {
        padding: 0px 10px;
        box-sizing: border-box;
        .titleTxt {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          height: 39px;
          text-align: center;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        .startTime {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 5px;
          img {
            width: 14px;
            height: 14px;
          }
          .txt {
            flex: 1;
            display: flex;
            justify-content: flex-start;

            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 14px;
            padding-left: 6px;
            box-sizing: border-box;
            padding-bottom: 5px;

            .sity {
              font-size: 10px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #666666;
            }
          }
        }
        p {
          margin-top: 5px;
          margin-bottom: 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
      .down {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 11px;
        text-align: center;
        padding: 10px 10px;
        box-sizing: border-box;
        margin-top: 10px;
        border-top: 1px solid #e0e0e0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 220px;
    height: 180px;
    margin: 0 auto;
  }
}
</style>
